import React from 'react';
import imgVectorStroke from '../../assets/sections/321c9b5a707885092ab66bbeb813697b15e373cf.svg';
import imgVectorStroke1 from '../../assets/sections/de1b27944d8f96be116e49ffc47d6877ff61e3fa.svg';
import imgFrame23 from '../../assets/sections/00d14b12320dbdbd6d51dff62ccdcdf99257c5cf.png';
import imgImage35Vectorized from '../../assets/sections/e78bfa07417196c0967a9ca8fb233a49e918d320.svg';
import imgGroup16 from '../../assets/sections/785d20c33fcef007179e9d33c99c7e7addd40fc5.svg';
import imgTopcvBrandArrow from '../../assets/sections/99fd6146d9489ef3c5120ef1dac1a5604c3819a1.png';

function OutlineArrowsAltArrowRight({ className }) {
  return (
    <div className={className || "overflow-clip relative size-[72px]"} data-node-id="2003:391">
      <div className="absolute inset-[17.71%_34.37%]" data-node-id="2003:392">
        <img alt="" className="absolute block max-w-none size-full" src={imgVectorStroke} />
      </div>
    </div>
  );
}

function OutlineArrowsAltArrowLeft({ className }) {
  return (
    <div className={className || "overflow-clip relative size-[72px]"} data-node-id="2003:389">
      <div className="absolute inset-[17.71%_34.37%_17.71%_34.38%]" data-node-id="2003:390">
        <img alt="" className="absolute block max-w-none size-full" src={imgVectorStroke1} />
      </div>
    </div>
  );
}

export default function CompanyTour() {
  return (
    <div className="bg-gradient-to-b from-[#00b14f] relative w-[1920px] h-[1080px] to-[#00474b] to-[155.19%]" data-node-id="2003:393">
      {/* TopCV brand arrow watermark */}
      <div className="absolute h-[775px] left-[-76px] top-[139px] w-[286px]" data-name="TOPCV_BRAND_THE-ARROW_WHITE 2" data-node-id="2003:394">
        <img alt="" className="absolute inset-0 max-w-none object-cover opacity-30 pointer-events-none size-full" src={imgTopcvBrandArrow} />
      </div>
      {/* Right panel */}
      <div className="absolute h-[1082px] left-[982px] top-0 w-[938px]" data-node-id="2003:395">
        <div aria-hidden="true" className="absolute inset-0 pointer-events-none">
          <div className="absolute inset-0 overflow-hidden">
            <img alt="" className="absolute h-full left-[-105.22%] max-w-none top-0 w-[205.18%]" src={imgFrame23} />
          </div>
          <div className="absolute bg-[#002e2a] inset-0" />
        </div>
        <p className="absolute font-['Alexandria',sans-serif] font-bold leading-[normal] left-[68px] text-[60px] text-white top-[173px] uppercase w-[782px]" data-node-id="2003:397">
          Khám phá môi trường doanh nghiệp
        </p>
        <p className="absolute font-['Alexandria',sans-serif] font-normal h-[234px] leading-[normal] left-[70px] text-[32px] text-white top-[380px] w-[793px]" data-node-id="2003:398">
          <b>Thời gian:</b> 07: 00 - 17:00 | Thứ 7, ngày 11.04.2026<br />
          <b>Địa điểm:</b> Nhà máy Brother & Khuôn viên trường Đại học Hàng Hải, thành phố Hải Phòng
        </p>
        <div className="cursor-pointer absolute content-stretch flex flex-col gap-[16px] items-center justify-center left-[68px] px-[42px] py-[36px] rounded-[16px] shadow-[0px_60px_104px_0px_rgba(0,0,0,0.05)] top-[550px] w-[805px]" data-node-id="2003:399"
          onClick={() => {
            window.open("https://forms.gle/MYSuK5Haef2ZJXFdA", "_blank")
          }}
        >
          <div aria-hidden="true" className="absolute bg-[#01b150] inset-0 pointer-events-none rounded-[16px]" />
          <p className="font-['Alexandria',sans-serif] font-bold leading-[1.5] relative shrink-0 text-[21px] text-center text-white whitespace-nowrap" data-node-id="204:6">
            KHÁM PHÁ NGAY
          </p>
          <div className="absolute inset-0 pointer-events-none rounded-[inherit] shadow-[inset_0px_0px_100px_0px_rgba(0,177,79,0.1)]" />
        </div>
        <p className="absolute font-['Alexandria',sans-serif] font-normal leading-[normal] left-[68px] opacity-50 text-[32px] text-white top-[108px] uppercase whitespace-nowrap" data-node-id="2003:419">
          Company Tour x Mock Interview
        </p>
      </div>
      {/* Vertical line */}
      <div className="absolute flex h-[904px] items-center justify-center left-[477px] top-[178px] w-0">
        <div className="-rotate-90 flex-none">
          <div className="h-0 relative w-[904px]" data-node-id="2003:420">
            <div className="absolute inset-[-52.5px_-5.81%]">
              <img alt="" className="block max-w-none size-full" src={imgGroup16} />
            </div>
          </div>
        </div>
      </div>
      {/* Timeline cards - left column */}
      <div className="absolute content-stretch flex flex-col gap-[16px] items-start left-[134px] px-[42px] py-[24px] rounded-[16px] shadow-[0px_60px_104px_0px_rgba(0,0,0,0.05)] top-[168px] w-[308px]" data-node-id="2003:424">
        <div aria-hidden="true" className="absolute bg-[rgba(255,255,255,0.3)] inset-0 pointer-events-none rounded-[16px]" />
        <p className="font-['Alexandria',sans-serif] font-normal leading-[normal] relative shrink-0 text-[#e9fffa] text-[24px] w-full" data-node-id="2003:425">
          07:00
        </p>
        <p className="font-['Alexandria',sans-serif] font-semibold leading-[normal] relative shrink-0 text-[#e9fffa] text-[18px] w-full" data-node-id="2003:426">
          Xuất phát từ Văn phòng TopCV
        </p>
        <div className="absolute inset-0 pointer-events-none rounded-[inherit] shadow-[inset_0px_0px_100px_0px_rgba(0,177,79,0.1)]" />
      </div>
      <div className="absolute content-stretch flex flex-col gap-[16px] items-start left-[134px] px-[42px] py-[24px] rounded-[16px] shadow-[0px_60px_104px_0px_rgba(0,0,0,0.05)] top-[453px] w-[308px]" data-node-id="2003:427">
        <div aria-hidden="true" className="absolute bg-[rgba(255,255,255,0.3)] inset-0 pointer-events-none rounded-[16px]" />
        <p className="font-['Alexandria',sans-serif] font-normal leading-[normal] relative shrink-0 text-[#e9fffa] text-[24px] w-full" data-node-id="2003:428">
          11:15 - 11:45
        </p>
        <p className="font-['Alexandria',sans-serif] font-semibold leading-[normal] relative shrink-0 text-[#e9fffa] text-[18px] w-full" data-node-id="2003:429">
          Ăn trưa
        </p>
        <div className="absolute inset-0 pointer-events-none rounded-[inherit] shadow-[inset_0px_0px_100px_0px_rgba(0,177,79,0.1)]" />
      </div>
      <div className="absolute content-stretch flex flex-col gap-[16px] items-start left-[134px] px-[42px] py-[24px] rounded-[16px] shadow-[0px_60px_104px_0px_rgba(0,0,0,0.05)] top-[716px] w-[308px]" data-node-id="2003:430">
        <div aria-hidden="true" className="absolute bg-[rgba(255,255,255,0.3)] inset-0 pointer-events-none rounded-[16px]" />
        <p className="font-['Alexandria',sans-serif] font-normal leading-[normal] relative shrink-0 text-[#e9fffa] text-[24px] w-full" data-node-id="2003:431">
          14:00 - 16:00
        </p>
        <p className="font-['Alexandria',sans-serif] font-semibold leading-[normal] relative shrink-0 text-[#e9fffa] text-[18px] w-full" data-node-id="2003:432">
          Mock Interview cùng doanh nghiệp
        </p>
        <div className="absolute inset-0 pointer-events-none rounded-[inherit] shadow-[inset_0px_0px_100px_0px_rgba(0,177,79,0.1)]" />
      </div>
      {/* Timeline cards - right column */}
      <div className="absolute content-stretch flex flex-col gap-[16px] items-start left-[512px] px-[42px] py-[24px] rounded-[16px] shadow-[0px_60px_104px_0px_rgba(0,0,0,0.05)] top-[304px] w-[308px]" data-node-id="2003:433">
        <div aria-hidden="true" className="absolute bg-[rgba(255,255,255,0.3)] inset-0 pointer-events-none rounded-[16px]" />
        <p className="font-['Alexandria',sans-serif] font-normal leading-[normal] relative shrink-0 text-[#e9fffa] text-[24px] w-full" data-node-id="2003:434">
          09:00 - 11:00
        </p>
        <p className="font-['Alexandria',sans-serif] font-semibold leading-[normal] relative shrink-0 text-[#e9fffa] text-[18px] w-full" data-node-id="2003:435">
          Tham quan doanh nghiệp + Mock Interview cùng sinh viên VMU
        </p>
        <div className="absolute inset-0 pointer-events-none rounded-[inherit] shadow-[inset_0px_0px_100px_0px_rgba(0,177,79,0.1)]" />
      </div>
      <div className="absolute content-stretch flex flex-col gap-[16px] items-start left-[512px] px-[42px] py-[24px] rounded-[16px] shadow-[0px_60px_104px_0px_rgba(0,0,0,0.05)] top-[567px] w-[308px]" data-node-id="2003:436">
        <div aria-hidden="true" className="absolute bg-[rgba(255,255,255,0.3)] inset-0 pointer-events-none rounded-[16px]" />
        <p className="font-['Alexandria',sans-serif] font-normal leading-[normal] relative shrink-0 text-[#e9fffa] text-[24px] w-full" data-node-id="2003:437">
          12:00 - 13:00
        </p>
        <p className="font-['Alexandria',sans-serif] font-semibold leading-[normal] relative shrink-0 text-[#e9fffa] text-[18px] w-full" data-node-id="2003:438">
          Di chuyển ra VMU - Mock Interview
        </p>
        <div className="absolute inset-0 pointer-events-none rounded-[inherit] shadow-[inset_0px_0px_100px_0px_rgba(0,177,79,0.1)]" />
      </div>
      <div className="absolute content-stretch flex flex-col gap-[16px] items-start left-[512px] px-[42px] py-[24px] rounded-[16px] shadow-[0px_60px_104px_0px_rgba(0,0,0,0.05)] top-[808px] w-[308px]" data-node-id="2003:439">
        <div aria-hidden="true" className="absolute bg-[rgba(255,255,255,0.3)] inset-0 pointer-events-none rounded-[16px]" />
        <p className="font-['Alexandria',sans-serif] font-normal leading-[normal] relative shrink-0 text-[#e9fffa] text-[24px] w-full" data-node-id="2003:440">
          16:15
        </p>
        <p className="font-['Alexandria',sans-serif] font-semibold leading-[normal] relative shrink-0 text-[#e9fffa] text-[18px] w-full" data-node-id="2003:441">
          Di chuyển về Hà Nội
        </p>
        <div className="absolute inset-0 pointer-events-none rounded-[inherit] shadow-[inset_0px_0px_100px_0px_rgba(0,177,79,0.1)]" />
      </div>
    </div>
  );
}
